import { render, staticRenderFns } from "./DeleteAccountDialog.vue?vue&type=template&id=2748ad68&scoped=true&"
import script from "./DeleteAccountDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccountDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteAccountDialog.vue?vue&type=style&index=0&id=2748ad68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748ad68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
